module.exports = {
  DomesticTrade: 'Nội thương',
  SiruiPleaseContactTheTroubleshooting: 'Gửi đơn ủy thác SIRUI thất bại, vui lòng liên hệ nhân viên kiểm tra:',
  OperationFailed: 'Thao tác thất bại',
  PleaseCheckTheData: 'Vui lòng chọn dữ liệu',
  LockedContactAHigherUnlock: 'Đã bị khóa, không thể in, vui lòng liên hệ quản lý cấp trên mở khóa!',
  AreCancelTheVoidingDocuments: 'Xác nhận hủy bỏ các chứng từ đã chọn?',
  PleaseFormInvoiceEtcVoid: 'Vui lòng xóa phiếu xác nhận chi phí, hóa đơn trước, sau đó hủy.',
  PleaseFromTheMasterVoid: 'Vui lòng tách phiếu nhỏ này khỏi phiếu chính, sau đó hủy.',
  PleaseFromThisMasterVoid: 'Vui lòng tách tất cả phiếu nhỏ khỏi phiếu chính này, sau đó hủy.',
  ThisThatRelevantDocumentsContinue: 'Nghiệp vụ này sẽ gửi phòng tài chính kiểm duyệt, trước khi gửi vui lòng xác nhận đã tải tài liệu lên hệ thống, có tiếp tục?',
  AttachmentContentIsTooLarge: 'Nội dung đính kèm quá lớn',
  ThereBillNumbersProfitPrinted: 'Có chi phí nước ngoài không có số hóa đơn hợp lệ, không thể in bảng phân tích lợi nhuận!',
  ThereBillNumbersProfitSubmitted: 'Có chi phí nước ngoài không có số hóa đơn hợp lệ, không thể gửi bảng phân tích lợi nhuận!',
  LockedPrintedOrEDINeeded: 'Do vượt hạn mức tín dụng, phiếu này đã bị khóa, không thể in hoặc EDI, vui lòng liên hệ cấp trên mở khóa khi cần!',
  PleaseTicketToBeAdded: 'Vui lòng chọn phiếu nhỏ cần thêm vào',
  AreCopyTheMastersInformation: 'Xác nhận sao chép thông tin người gửi/nhận từ phiếu chính?',
  MasterPleaseMaintainTheFirst: 'Số phiếu chính không được để trống, vui lòng nhập số phiếu chính trước',
  PleaseTicketToBeEdited: 'Vui lòng chọn phiếu nhỏ cần chỉnh sửa',
  Add: 'Thêm mới',
  AirImportCargoOperationDetails: 'Chi tiết thao tác hàng nhập khẩu vận chuyển bằng đường hàng không',
  ThisAlreadyAFormalBusiness: 'Phiếu này đã là nghiệp vụ chính thức.'
}
